// Hook do aktualizacji zadania – PUT /sales-crm/tasks/:id

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmTaskRequest {
  name: string;
  due_date: string;
  priority: number | null;
  status: number | string;
  type: string | null;
  trader_id: number | null;
  client_id: number | null;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmTask = (id: number, data: IPutSalesCrmTaskRequest): Promise<IResponse> =>
  axios.put(`/sales-crm/tasks/${id}`, data);

export const usePutSalesCrmTask = (
  id: number,
  options?: UseMutationOptions<IResponse, IError, IPutSalesCrmTaskRequest>
) => useMutation((data: IPutSalesCrmTaskRequest) => putSalesCrmTask(id, data), options);
